import React, { useEffect, useState } from "react";
import { Button } from "@/components/atoms/Button";
import { type CarouselApi } from "@/components/molecules/Carousel";
import ArrowLeft from "@/icons/__generated__/ArrowLeft/ArrowLeft32";
import ArrowRight from "@/icons/__generated__/ArrowRight/ArrowRight32";

interface CarouselSectionArrowProps {
  direction: "left" | "right";
  onClick?: () => void;
  api: CarouselApi;
}

export const CarouselSectionArrow: React.FC<CarouselSectionArrowProps> = ({
  direction,
  onClick,
  api,
}) => {
  const [canScroll, setCanScroll] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!api) return;

    const handleSelect = () => {
      setCanScroll(
        direction === "left" ? api.canScrollPrev() : api.canScrollNext(),
      );
    };

    api.on("select", handleSelect);
    handleSelect(); // Initial check

    return () => {
      api.off("select", handleSelect);
    };
  }, [api, direction]);

  const arrowIcon = direction === "left" ? <ArrowLeft /> : <ArrowRight />;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (direction === "left") {
      api?.scrollPrev();
    } else {
      api?.scrollNext();
    }
  };

  return (
    <Button
      appearance={"black"}
      variant={"ghost"}
      iconOnly
      onClick={handleClick}
      disabled={!canScroll}
      aria-label={`carousel-arrow-${direction}`}
    >
      {arrowIcon}
    </Button>
  );
};
